module.exports = __webpack_public_path__ + "img/IMG-20191106-WA0027.10a205dd.jpg";